import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

const communityInfoHeight = 176;

export const useStyles = makeStyles<Theme>()((theme) => ({
  communityInfoWrapper: {
    ...theme.mixins.appContainer,
    display: 'flex',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  avatar: {
    width: communityInfoHeight,
    height: communityInfoHeight,
    flexShrink: 0,
    borderRadius: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: 220,
    },
    [theme.breakpoints.down('sm')]: {
      height: 168,
    },
  },
  communityDetails: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  detailsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
    },
  },
  postsWrapper: {
    flex: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  cardContainer: {
    ...theme.mixins.appContainer,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  postHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  postHeaderText: {
    flex: 1,
  },
  postMediaPlaceholder: {
    width: '100%',
    height: 168,
    borderRadius: theme.spacing(1),
  },
  postFooter: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  relationsWrapper: {
    flex: 1,
    minWidth: 280,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      minWidth: '100%',
    },
  },
  relationList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  relationListRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));
